/* FAMILIA LITPER v1.1 (03-oct-2026: + Lyan Señales, hoja de medidas a escala, Sofía revisa el formulario) · v1 (02-oct-2026) · Lyan, Lyan bebé y Sofía en toda la tienda.
   Sin librerías. Configuración en snippets/litper-familia.liquid (window.LF).
   Reglas de calidad: no tapa el botón de pedir, respeta "reducir movimiento", nada corre en bucle infinito:
   cada observador se apaga solo (stop-condition) y la escena deja de rotar mensajes tras 3 vueltas.
   Medición: track() -> fbq trackCustom 'lf_<evento>' + dataLayer. */
(function(){
'use strict';
var D=document,W=window,LF=W.LF||{},M=LF.modulos||{},IMG=LF.img||{};
var RM=W.matchMedia&&W.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ---------- apagado rápido para comparar (?lf=0 / ?lf=1) ---------- */
try{var q=new URLSearchParams(location.search).get('lf');if(q==='0')sessionStorage.setItem('lf_off','1');if(q==='1')sessionStorage.removeItem('lf_off');
  if(sessionStorage.getItem('lf_off')){D.documentElement.classList.add('lf-off');return;}}catch(e){}

function track(n,d){try{if(W.fbq)W.fbq('trackCustom','lf_'+n,d||{});}catch(e){}try{(W.dataLayer=W.dataLayer||[]).push(Object.assign({event:'lf_'+n},d||{}));}catch(e){}}
function wa(txt){return 'https://wa.me/'+(LF.wa||'573022658970')+'?text='+encodeURIComponent(txt);}
function esc(s){return String(s||'').replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
function ready(f){if(D.readyState==='loading')D.addEventListener('DOMContentLoaded',f);else f();}
/* observa el DOM hasta que fn() devuelva true o pasen ms milisegundos */
function until(fn,ms){if(fn())return;var mo=new MutationObserver(function(){if(fn()){mo.disconnect();}});mo.observe(D.body,{childList:true,subtree:true});setTimeout(function(){mo.disconnect();},ms||20000);}
D.addEventListener('click',function(e){var a=e.target.closest&&e.target.closest('[data-lf-ev]');if(a)track(a.getAttribute('data-lf-ev'));},true);

/* =========================================================
   1. ESCENA DEL INICIO (3D por capas)
   ========================================================= */
function escena(){
  var S=D.getElementById('lfe');if(!S||M.escena===false)return;
  var rig=S.querySelector('.lfe-rig'),stage=S.querySelector('.lfe-stage'),bub=S.querySelector('.lfe-bubble span'),bubP=S.querySelector('.lfe-bubble'),
      lyan=S.querySelector('.lfe-lyan'),cub=S.querySelector('.lfe-cub');
  var MSG=['¡Pagas cuando te llega!','Envío gratis a toda Colombia.','Sofía te confirma por WhatsApp.','Te llega en '+(LF.envio||'2 a 5 días hábiles')+'.'];
  var CUB=['¡Hola! Soy Lyan bebé.','Mi almohada es Litper 😴','¡Abrazos suaves para tu casa!'];
  var i=0,ci=0,t=null,turns=0,seen=false;
  function say(txt){if(!bub)return;bubP.classList.add('lfe-out');setTimeout(function(){bub.textContent=txt;bubP.classList.remove('lfe-out');},280);}
  function next(){i=(i+1)%MSG.length;say(MSG[i]);if(i===0&&++turns>=3)stop();}
  function start(){if(RM||t)return;t=setInterval(function(){if(!D.hidden)next();},4600);}
  function stop(){clearInterval(t);t=null;}
  function hop(el){el.classList.remove('lfe-hop');void el.offsetWidth;el.classList.add('lfe-hop');}
  lyan.addEventListener('click',function(){hop(lyan);stop();next();});
  cub.addEventListener('click',function(){hop(cub);stop();say(CUB[ci++%CUB.length]);});
  /* entra en pantalla: Lyan bebé se asoma y arrancan los mensajes */
  if('IntersectionObserver' in W){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){
      if(e.isIntersecting){S.classList.add('lfe-on');start();if(!seen){seen=true;track('escena_vista');}}else stop();});},{threshold:.35});
    io.observe(S);
  }else{S.classList.add('lfe-on');}
  if(RM)return;
  /* inclinación 3D: mouse en escritorio, scroll en celular. Un solo rAF por cuadro. */
  var raf=0,rx=0,ry=0;
  function apply(){raf=0;rig.style.setProperty('--rx',rx.toFixed(2)+'deg');rig.style.setProperty('--ry',ry.toFixed(2)+'deg');S.style.setProperty('--sx',(-ry*2.2).toFixed(1));}
  function sched(){if(!raf)raf=requestAnimationFrame(apply);}
  var fine=W.matchMedia&&W.matchMedia('(hover:hover) and (pointer:fine)').matches;
  if(fine){
    stage.addEventListener('pointermove',function(e){var r=stage.getBoundingClientRect();var x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;ry=x*16;rx=-y*8;sched();});
    stage.addEventListener('pointerleave',function(){rx=0;ry=0;sched();});
  }else{
    W.addEventListener('scroll',function(){var r=S.getBoundingClientRect();if(r.bottom<0||r.top>innerHeight)return;var p=(r.top+r.height/2)/innerHeight-.5;ry=p*-18;rx=p*5;sched();},{passive:true});
  }
}

/* =========================================================
   2. FICHA DE PRODUCTO: Lyan bebé asomado + Sofía
   ========================================================= */
function ficha(){
  if(M.ficha===false||!/^\/products\//.test(location.pathname))return;
  var prod=LF.producto||(D.querySelector('meta[property="og:title"]')||{}).content||'este producto';
  function visibleBtn(){var bs=[].slice.call(D.querySelectorAll('main #rsi_buy_now_button'));
    return bs.filter(function(b){return b.offsetParent!==null&&!b.closest('#rsi_form_wrapper')&&b.getBoundingClientRect().width>200;})[0];}
  until(function(){
    var b=visibleBtn();if(!b)return false;
    if(b.parentElement.querySelector(':scope > .lf-asoma'))return true;
    var host=b.parentElement;host.classList.add('lf-host');
    /* Lyan bebé detrás del botón: solo se ve la cabeza, como si se asomara a la caja */
    var c=D.createElement('div');c.className='lf-asoma lf-x';c.setAttribute('role','button');c.tabIndex=0;c.setAttribute('aria-label','Lyan bebé te cuenta cómo pagas');
    c.innerHTML='<span class="lf-say">¡Pagas <b>cuando te llega</b>!</span><img src="'+IMG.asoma+'" alt="" width="300" height="266" loading="lazy" decoding="async">';
    host.insertBefore(c,b);
    var said=0;function talk(){c.classList.add('lf-talk');clearTimeout(c._t);c._t=setTimeout(function(){c.classList.remove('lf-talk');},3200);}
    c.addEventListener('click',function(){talk();track('ficha_toca_bebe');});c.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();talk();}});
    if('IntersectionObserver' in W){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){c.classList.add('lf-in');
        if(!said++){setTimeout(talk,1100);track('ficha_bebe_visto');}io.disconnect();}});},{threshold:.6});io.observe(b);}
    else c.classList.add('lf-in');
    /* Sofía debajo del botón */
    if(!host.parentElement.querySelector('.lf-sofia')){
      var s=D.createElement('div');s.className='lf-sofia lf-x';
      s.innerHTML='<img src="'+IMG.sofia+'" alt="Sofía, asesora Litper" width="96" height="96" loading="lazy" decoding="async">'+
        '<div><b>Sofía</b> te confirma tu pedido por WhatsApp antes de enviarlo.<br>'+
        '<a href="'+esc(wa('Hola Sofía, tengo una pregunta sobre '+prod))+'" target="_blank" rel="noopener" data-lf-ev="ficha_sofia_wa">¿Dudas con la medida o el color? Pregúntale →</a></div>';
      var after=host;while(after.parentElement&&after.parentElement.children.length===1&&!after.parentElement.matches('main,form,product-form-component'))after=after.parentElement;
      after.insertAdjacentElement('afterend',s);
    }
    return true;
  },25000);
}

/* =========================================================
   3. FORMULARIO CONTRAENTREGA (Releasit): Sofía arriba
   ========================================================= */
function checkout(){
  if(M.checkout===false)return;
  var dead=false,busy=false;
  function paint(){var w=D.getElementById('rsi_form_wrapper');if(!w)return;var pc=w.querySelector('.rsi-form-page-content');if(!pc||pc.querySelector('.lf-ck'))return;
    var d=D.createElement('div');d.className='lf-ck lf-x';
    d.innerHTML='<img src="'+IMG.sofia+'" alt="Sofía, asesora Litper" width="96" height="96"><div><b>Sofía</b> revisa tu pedido y te escribe por WhatsApp para confirmarlo antes de despacharlo.</div>';
    pc.insertBefore(d,pc.firstChild);track('checkout_sofia_vista');}
  var mo=new MutationObserver(function(){if(busy||dead)return;busy=true;setTimeout(function(){busy=false;try{paint();}catch(e){}},80);});
  mo.observe(D.body,{childList:true,subtree:true});paint();
  setTimeout(function(){dead=true;mo.disconnect();},600000); /* stop: 10 min */
}

/* =========================================================
   4. GRACIAS: Lyan celebra + Sofía en el paso de WhatsApp
   ========================================================= */
function gracias(){
  if(M.gracias===false||!/\/pages\/gracias/.test(location.pathname))return;
  until(function(){
    var R=D.getElementById('lpGracias');if(!R)return false;
    var chips=R.querySelector('.hero .chips');
    if(chips&&!R.querySelector('.lf-ty')){var f=D.createElement('div');f.className='lf-ty lf-x';
      f.innerHTML='<p>¡Tu pedido está en buenas manos!</p><img class="lf-ty-a" src="'+IMG.brazos+'" alt="Lyan, el león de Litper" width="334" height="640"><img class="lf-ty-b" src="'+IMG.bebe+'" alt="Lyan bebé" width="313" height="520">';
      chips.insertAdjacentElement('afterend',f);}
    var st=R.querySelector('.tl li.on b');
    if(st&&!st.querySelector('img')){st.innerHTML='<span class="lf-ty-step"><img src="'+IMG.sofia+'" alt="" width="96" height="96">Hoy Sofía te escribe por WhatsApp</span>';}
    track('gracias_vista');return true;
  },15000);
}

/* =========================================================
   5. CARRITO VACÍO y 404
   ========================================================= */
function vacio(){
  if(M.vacio===false)return;
  var tpl=LF.plantilla;
  if(tpl==='404'){until(function(){var h=D.querySelector('main h1, main .main-404 h2');if(!h)return false;if(D.querySelector('.lf-vacio'))return true;
      var v=D.createElement('div');v.className='lf-vacio lf-x';v.innerHTML='<img src="'+IMG.bostezo+'" alt="Lyan bebé bostezando" width="311" height="420">';
      h.insertAdjacentElement('beforebegin',v);
      /* el tema trae esta página en inglés: se traduce aquí sin tocar el idioma de la tienda */
      var T=[[/^Page not found$/i,'Esta página se quedó dormida'],[/^The link may be incorrect, or the page has been removed\.?$/i,'Puede que el enlace esté mal o que la página ya no exista. Lyan bebé te lleva a lo que sí está despierto.'],
        [/^Continue shopping$/i,'Ver toda la tienda'],[/^Discover something new$/i,'Descubre algo nuevo']];
      var w=D.createTreeWalker(D.querySelector('main'),NodeFilter.SHOW_TEXT,null),n;
      while(n=w.nextNode()){var t=n.nodeValue.trim();if(!t)continue;T.forEach(function(r){if(r[0].test(t))n.nodeValue=n.nodeValue.replace(t,r[1]);});}
      track('vista_404');return true;},8000);}
  /* carrito vacío: página /cart y carrito lateral */
  /* Horizon: .cart-page--empty > .cart-page__title ; otros temas: contenedores *empty* */
  function cartEmpty(root){var e=root.querySelector('.cart-page--empty, .cart-items__empty, .cart__empty, [class*="empty-state"], .cart-drawer__empty, .cart-empty');
    if(!e||e.querySelector('.lf-vacio')||!e.offsetParent)return;
    var v=D.createElement('div');v.className='lf-vacio lf-x';v.innerHTML='<img src="'+IMG.sentado+'" alt="Lyan bebé sentado con su almohada" width="299" height="420"><p><b>Lyan bebé está esperando</b> tu primer producto.</p>';
    var ref=e.querySelector('.cart-page__title')||e.firstChild;ref.parentNode.insertBefore(v,ref);track('carrito_vacio');}
  if(tpl==='cart')until(function(){cartEmpty(D);return !!D.querySelector('.lf-vacio')||!!D.querySelector('.cart-items__table-row');},8000);
  D.addEventListener('click',function(e){if(e.target.closest&&e.target.closest('.header__icon--cart, cart-icon, [href="/cart"]')){[300,900].forEach(function(ms){setTimeout(function(){var dr=D.querySelector('cart-drawer-component');if(dr)cartEmpty(dr);},ms);});}},true);
}

/* =========================================================
   7. LYAN SEÑALES (v26 · 03-oct-2026): alertas honestas que responden a lo que hace el cliente
   Reglas: todo lo que dicen ya está en la ficha (fecha de llegada, tabla de medidas, elástico, WhatsApp oficial);
   cero escasez falsa; máx. 1 alerta cada 25 s y 4 por visita; cada alerta 1 vez por sesión; se cierra con un toque;
   nunca tapa el botón de pedir (sale arriba, tipo "isla" de vidrio). Evento: lf_senal_<id> / lf_senal_<id>_accion.
   ========================================================= */
function ss(k,v){try{if(v===undefined)return sessionStorage.getItem(k);sessionStorage.setItem(k,v);}catch(e){return null;}}
function lsj(k,v){try{if(v===undefined)return JSON.parse(localStorage.getItem(k)||'null');localStorage.setItem(k,JSON.stringify(v));}catch(e){return null;}}
function norm(s){return String(s||'').normalize('NFD').replace(/[̀-ͯ]/g,'').toUpperCase().trim();}

/* opciones de variante de la ficha (Horizon): radios agrupados por fieldset con legend "Color :" / "Tamaño :" */
function optGroups(){
  var g={};[].slice.call(D.querySelectorAll('main variant-picker fieldset, main .variant-picker fieldset')).forEach(function(fs){
    var lg=fs.querySelector('legend');var name=norm(lg?lg.textContent.split(':')[0]:'');
    var ins=[].slice.call(fs.querySelectorAll('input[type=radio]'));if(!ins.length)return;
    if(/TAMANO|MEDIDA|TALLA/.test(name))g.size=ins;else if(/COLOR|DISENO/.test(name))g.color=ins;});
  return g;
}
function checkedVal(ins){var c=(ins||[]).filter(function(i){return i.checked;})[0];return c?c.value:'';}
function pick(ins,val){var t=(ins||[]).filter(function(i){return norm(i.value)===norm(val);})[0];if(!t)return false;
  if(!t.checked){var l=t.id&&D.querySelector('label[for="'+t.id+'"]');(l||t).click();}return true;}

var SE={n:0,last:0,box:null,tm:null,max:4,gap:/[?&]lf_test=1/.test(location.search)?1500:25000};
function senalBox(){
  if(SE.box)return SE.box;
  var b=D.createElement('div');b.className='lf-senal lf-x';b.setAttribute('role','status');b.setAttribute('aria-live','polite');
  b.innerHTML='<img class="lf-senal-av" alt="" width="40" height="40"><div class="lf-senal-tx"></div><button type="button" class="lf-senal-go"></button><button type="button" class="lf-senal-x" aria-label="Cerrar aviso">×</button>';
  D.body.appendChild(b);SE.box=b;
  b.querySelector('.lf-senal-x').addEventListener('click',function(){hideSenal();});
  b.addEventListener('pointerenter',function(){clearTimeout(SE.tm);});
  b.addEventListener('pointerleave',function(){SE.tm=setTimeout(hideSenal,3500);});
  return b;
}
function hideSenal(){if(SE.box)SE.box.classList.remove('lf-on');clearTimeout(SE.tm);}
/* s = {id, who:'bebe'|'sofia', html, accion:{txt, fn}|null, force} */
function senal(s){
  if(D.querySelector('#rsi_form_wrapper .rsi-form-main')&&D.getElementById('rsi_form_wrapper').offsetParent!==null)return false; /* nunca encima del formulario */
  if(ss('lf_s_'+s.id))return false;
  var now=Date.now(),n=+(ss('lf_s_n')||0);
  if(!s.force&&n>=SE.max)return false;
  /* si otro aviso acaba de salir, este espera su turno (una vez) y vuelve a comprobar que siga aplicando */
  var busyNow=SE.box&&SE.box.classList.contains('lf-on');
  if(!s.force&&(now-SE.last<SE.gap||busyNow)){if((s._w=(s._w||0)+1)<=3){setTimeout(function(){if(!s.cond||s.cond())senal(s);},Math.max(SE.gap-(now-SE.last),1500)+300);}return false;}
  var b=senalBox();SE.last=now;ss('lf_s_n',String(n+1));ss('lf_s_'+s.id,'1');
  var av=b.querySelector('.lf-senal-av');av.src=s.who==='sofia'?IMG.sofia:IMG.asoma;b.classList.toggle('lf-sofia-av',s.who==='sofia');
  b.querySelector('.lf-senal-tx').innerHTML=s.html;
  var go=b.querySelector('.lf-senal-go');
  if(s.accion){go.hidden=false;go.textContent=s.accion.txt;go.onclick=function(){track('senal_'+s.id+'_accion');hideSenal();s.accion.fn();};}else{go.hidden=true;go.onclick=null;}
  /* debajo del encabezado fijo, si lo hay */
  var hd=D.querySelector('header-component, .header-wrapper, #header-group');var top=12;
  if(hd){var r=hd.getBoundingClientRect();if(r.bottom>0&&r.bottom<160)top=Math.round(r.bottom+10);}
  b.style.top=top+'px';
  requestAnimationFrame(function(){b.classList.add('lf-on');});
  clearTimeout(SE.tm);SE.tm=setTimeout(hideSenal,s.accion?11000:7500);
  track('senal_'+s.id);return true;
}

/* hoja de medidas a escala: lee la tabla real de la ficha (#sizeGuideNote) y marca la variante al tocar */
function hojaMedidas(g){
  var rows=[].slice.call(D.querySelectorAll('#sizeGuideNote table tbody tr, .size-table tbody tr')).map(function(tr){
    var td=tr.querySelectorAll('td');if(td.length<3)return null;
    var w=parseInt(td[1].textContent,10),l=parseInt(td[2].textContent,10);if(!w||!l)return null;
    var nm=td[0].textContent.trim();
    var inp=(g.size||[]).filter(function(i){var a=norm(i.value),b=norm(nm);return a===b||a.indexOf(b)===0||b.indexOf(a)===0||a.replace(/O$/,'A')===b||b.replace(/O$/,'A')===a;})[0];
    return inp?{nm:nm,w:w,l:l,inp:inp}:null;}).filter(Boolean);
  if(rows.length<2)return null;
  var maxW=Math.max.apply(null,rows.map(function(r){return r.w;}));
  var tip=/si dudas,? elige la mayor/i.test((D.querySelector('main')||D.body).textContent)?'<p class="lf-hm-tip">Si dudas entre dos medidas, elige la mayor.</p>':'';
  var cur=checkedVal(g.size);
  var sh=D.createElement('div');sh.className='lf-hm lf-x';sh.setAttribute('role','dialog');sh.setAttribute('aria-modal','true');sh.setAttribute('aria-label','Elige la medida de tu cama');
  sh.innerHTML='<div class="lf-hm-card"><button type="button" class="lf-hm-x" aria-label="Cerrar">×</button>'+
    '<div class="lf-hm-head"><img src="'+IMG.asoma+'" alt="" width="64" height="57"><div><b>¿De qué ancho es tu cama?</b><span>Mide el ancho del colchón con un metro y toca la tuya.</span></div></div>'+
    '<div class="lf-hm-list">'+rows.map(function(r,i){var pct=Math.round(r.w/maxW*100);
      return '<button type="button" class="lf-hm-row'+(norm(r.inp.value)===norm(cur)?' is-cur':'')+'" data-i="'+i+'">'+
        '<span class="lf-hm-bed" style="--w:'+pct+'%"><i></i></span><span class="lf-hm-nm">'+esc(r.nm)+'</span><span class="lf-hm-cm">'+r.w+' × '+r.l+' cm</span></button>';}).join('')+
    '</div>'+tip+'</div>';
  D.body.appendChild(sh);D.body.classList.add('lf-hm-open');
  function close(){sh.classList.remove('lf-on');D.body.classList.remove('lf-hm-open');setTimeout(function(){sh.remove();},260);D.removeEventListener('keydown',esck);}
  function esck(e){if(e.key==='Escape')close();}
  D.addEventListener('keydown',esck);
  sh.addEventListener('click',function(e){
    if(e.target===sh||e.target.closest('.lf-hm-x')){close();return;}
    var row=e.target.closest('.lf-hm-row');if(!row)return;var r=rows[+row.dataset.i];
    pick([r.inp],r.inp.value);track('medida_elegida',{medida:r.nm});
    [].slice.call(sh.querySelectorAll('.lf-hm-row')).forEach(function(x){x.classList.toggle('is-cur',x===row);});
    setTimeout(close,420);
  });
  requestAnimationFrame(function(){sh.classList.add('lf-on');var f=sh.querySelector('.lf-hm-row.is-cur')||sh.querySelector('.lf-hm-row');if(f)f.focus({preventScroll:true});});
  track('medida_abierta');return sh;
}

function senales(){
  if(M.senales===false||!/^\/products\//.test(location.pathname))return;
  var prod=LF.producto||'este producto',handle=(location.pathname.split('/')[2]||'').split('?')[0];
  var main=D.querySelector('main')||D.body,g=optGroups(),touchedSize=false,colorT=null;
  var txt=main.textContent||'';
  function visibleBuy(){return [].slice.call(D.querySelectorAll('main #rsi_buy_now_button')).filter(function(b){return b.offsetParent!==null&&!b.closest('#rsi_form_wrapper')&&b.getBoundingClientRect().width>200;})[0];}

  /* 1) volviste: retoma la última elección guardada en este navegador (30 días) */
  var saved=lsj('lf_ult_'+handle);
  if(saved&&Date.now()-saved.t<30*864e5&&(saved.c||saved.s)){
    var cc=checkedVal(g.color),cs=checkedVal(g.size);
    if((saved.c&&norm(saved.c)!==norm(cc))||(saved.s&&norm(saved.s)!==norm(cs))){
      var lbl=[saved.c,saved.s].filter(Boolean).map(function(x){return x.charAt(0)+x.slice(1).toLowerCase();}).join(' · ');
      setTimeout(function(){senal({id:'volviste',who:'bebe',html:'<b>¡Volviste!</b> ¿Seguimos con '+esc(lbl)+'?',force:true,
        accion:{txt:'Sí, usar',fn:function(){if(saved.c)pick(optGroups().color,saved.c);setTimeout(function(){if(saved.s)pick(optGroups().size,saved.s);},450);}}});},2500);
    }
  }
  function remember(){lsj('lf_ult_'+handle,{c:checkedVal(g.color),s:checkedVal(g.size),t:Date.now()});}

  /* 2) llegada: la fecha real que ya calcula la ficha */
  setTimeout(function(){var e=D.querySelector('.lpk-eta');if(!e)return;var line=(e.innerText||e.textContent).split('\n')[0].trim();
    var m=line.match(/te llega entre (.+?)\.?$/i);if(!m)return;
    senal({id:'llegada',who:'bebe',html:'Si pides hoy, <b>te llega entre '+esc(m[1])+'</b>. Pagas cuando lo recibes.'});},SE.gap<5000?2500:6500);

  /* 3) medida: eligió color pero no medida → hoja de medidas a escala */
  main.addEventListener('change',function(e){
    var t=e.target;if(!t||t.type!=='radio')return;
    g=optGroups();
    if(g.size&&g.size.indexOf(t)>-1){touchedSize=true;remember();
      if(/KING|QUEEN/.test(norm(t.value))&&/estira hasta 40 ?cm/i.test(txt))
        senal({id:'grande',who:'bebe',html:'Su elástico <b>estira hasta 40 cm</b> de alto: abraza también los colchones gruesos.'});
    }
    if(g.color&&g.color.indexOf(t)>-1){remember();clearTimeout(colorT);
      if(!touchedSize&&g.size)colorT=setTimeout(function(){if(touchedSize)return;
        senal({id:'medida',who:'bebe',cond:function(){return !touchedSize;},html:'Lindo color. Ahora, <b>¿de qué ancho es tu cama?</b> Te ayudo a no equivocarte.',
          accion:{txt:'Elegir medida',fn:function(){hojaMedidas(optGroups());}}});},SE.gap<5000?2000:9000);}
  },true);

  /* 4) duda: 40 s sin moverse en la ficha → Sofía por WhatsApp oficial */
  var idleT=null;function bump(){clearTimeout(idleT);idleT=setTimeout(function(){if(D.visibilityState!=='visible')return;
    senal({id:'duda',who:'sofia',html:'¿Dudas con la medida o el color? <b>Escríbele a Sofía</b> por WhatsApp.',
      accion:{txt:'Escribir',fn:function(){W.open(wa('Hola Sofía, tengo una pregunta sobre '+prod),'_blank','noopener');}}});},SE.gap<5000?8000:40000);}
  ['scroll','pointerdown','keydown'].forEach(function(ev){W.addEventListener(ev,bump,{passive:true});});bump();
  setTimeout(function(){clearTimeout(idleT);['scroll','pointerdown','keydown'].forEach(function(ev){W.removeEventListener(ev,bump);});},600000); /* stop: 10 min */

  /* 5) antes de irte: cursor a la barra (escritorio) o subida brusca tras leer (celular). Una vez por sesión. */
  var deep=false,lastY=W.scrollY,lastT=Date.now();
  function salida(){senal({id:'salida',who:'bebe',html:'Antes de irte: <b>pides hoy y pagas solo cuando te llega</b>. Envío gratis.',
    accion:{txt:'Pedir ahora',fn:function(){var b=visibleBuy();if(b){b.scrollIntoView({behavior:RM?'auto':'smooth',block:'center'});setTimeout(function(){b.click();},RM?0:450);}}}});}
  D.addEventListener('mouseout',function(e){if(!e.relatedTarget&&e.clientY<=0&&deep)salida();});
  W.addEventListener('scroll',function(){var y=W.scrollY,t=Date.now();if(y>innerHeight*1.5)deep=true;
    if(deep&&lastY-y>900&&t-lastT<700)salida();if(t-lastT>700){lastY=y;lastT=t;}},{passive:true});
}

/* =========================================================
   8. SOFÍA REVISA TU FORMULARIO (v26): avisos en vivo para que el pedido llegue a la primera
   Nunca bloquea el envío. Campos verificados en litper-rsi-popup: first_name, phone, address, civic_number, city.
   Evento: lf_form_<campo>_aviso (una vez por campo).
   ========================================================= */
function formSofia(){
  if(M.formSofia===false)return;
  var R={
    first_name:function(v){return v.split(/\s+/).filter(function(x){return x.length>1;}).length>=2?{ok:'Perfecto.'}:{tip:'Escribe <b>nombre y apellido</b>: así la transportadora te encuentra.'};},
    phone:function(v){var d=v.replace(/\D/g,'');if(d.length>10)d=d.slice(-10);return /^3\d{9}$/.test(d)?{ok:'Sofía te escribe a este número para confirmar.'}:{tip:'Revisa tu celular: son <b>10 dígitos</b> y empieza por 3.'};},
    address:function(v){return /\d/.test(v)&&v.length>=6?{ok:'Dirección clara.'}:{tip:'Agrega el <b>número de la casa</b> (ej: Calle 10 # 5-23) para que tu pedido no se pierda.'};},
    civic_number:function(v){return v.length>=3?{ok:'Gracias, eso ayuda al mensajero.'}:{tip:'Un barrio o punto de referencia ayuda mucho: una tienda, un parque, el color de la puerta.',soft:1};},
    city:function(v){return v.length>=3?{ok:''}:null;}
  };
  var told={};
  function hintFor(inp){var row=inp.closest('.rsi-text-input-row, .rsi-select-input-row')||inp.parentElement;
    var h=row.nextElementSibling&&row.nextElementSibling.classList.contains('lf-hint')?row.nextElementSibling:null;
    if(!h){h=D.createElement('p');h.className='lf-hint lf-x';row.insertAdjacentElement('afterend',h);}return h;}
  function check(inp,live){
    var f=R[inp.name];if(!f)return;var v=String(inp.value||'').trim();
    if(!v&&inp.name!=='civic_number'){var row0=inp.closest('.rsi-text-input-row, .rsi-select-input-row')||inp.parentElement,h0=row0.nextElementSibling;if(h0&&h0.classList.contains('lf-hint')){h0.className='lf-hint lf-x';h0.innerHTML='';}return;}
    var r=f(v);if(!r)return;var h=hintFor(inp);
    if(r.ok!==undefined){h.className='lf-hint lf-x is-ok';h.innerHTML=r.ok?'<i>✓</i><span>'+r.ok+'</span>':'';}
    else if(!live||h.classList.contains('is-tip')){h.className='lf-hint lf-x is-tip'+(r.soft?' is-soft':'');
      h.innerHTML='<img src="'+IMG.sofia+'" alt="" width="22" height="22"><span>'+r.tip+'</span>';
      if(!told[inp.name]){told[inp.name]=1;track('form_'+inp.name+'_aviso');}}
  }
  D.addEventListener('focusout',function(e){var i=e.target;if(i&&i.closest&&i.closest('#rsi_form_wrapper')&&i.name&&R[i.name])check(i,false);},true);
  D.addEventListener('input',function(e){var i=e.target;if(i&&i.closest&&i.closest('#rsi_form_wrapper')&&i.name&&R[i.name])check(i,true);},true);
}

ready(function(){try{escena();}catch(e){}try{ficha();}catch(e){}try{checkout();}catch(e){}try{gracias();}catch(e){}try{vacio();}catch(e){}try{senales();}catch(e){}try{formSofia();}catch(e){}});
})();
